<!--<div class="base-card {{dataPlan.colorCard}}">
    <div class="base-card__image">
        <picture>
            <source media="(min-width: 960px)" srcset="{{image_url + dataPlan.image_url}}.png">
            <img class="img-responsive" src="{{image_url + dataPlan.image_url}}-mobile.png" alt="happy people image">
        </picture>
        <span *ngIf="dataPlan.discount > 0  && dataPlan.discount !== null" class="discount-rate bg-tertiary-base text-grayscale-white text-xsmall">-{{dataPlan.discount}}%</span>
    </div>
    <div class="base-card__description">
        <span class="type">{{dataPlan.name}}</span>
        <span class="price">${{dataPlan.priceDiscount.toLocaleString()}}<small class="price__month">Mes</small></span>
        <button *ngIf="!selectedOne" class="button tertiary px-small py-xsmall rounded text-xsmall" type="button" (click)="selectPlan()">Añadir a carrito</button>
        <span *ngIf="selectedOne" class="aprove">Base seleccionada</span>
    </div>
    <div class="base-card__properties">
        <ul class="list">
            <li class="item" *ngFor="let item of dataPlan.summary; index as i">
                <span *ngIf="this.cookieCiencuadras.getCookie('planType') === '1' " class="icon icon-check_circle_outline"></span>{{dataPlan.summary[i]}}
            </li>
        </ul>
    </div>
</div>-->
<div class="base-card__properties base_label">
    <div>
        <input *ngIf="idPlan != dataPlan.id" type="radio" class="btn_radio" id="{{dataPlan.id}}" name="radio_group" (click)="selectPlan(dataPlan)"/>
        <input *ngIf="idPlan == dataPlan.id" type="radio" checked class="btn_radio" id="{{dataPlan.id}}" name="radio_group" (click)="selectPlan(dataPlan)"/>
        <label *ngIf="dataPlan.detailModal.validity == 1" for="{{dataPlan.id}}">Paga {{dataPlan.detailModal.validity}} mes por: </label>
        <label *ngIf="dataPlan.detailModal.validity > 1" for="{{dataPlan.id}}">Paga {{dataPlan.detailModal.validity}} meses por: </label>
    </div>
    <div class="filling-card">
        <span class="text_span">${{dataPlan.priceDiscount.toLocaleString()}}</span><span *ngIf="dataPlan.discount > 0" style="color: #FFF;"> y ahorrate el {{dataPlan.discount}}%</span>
    </div>
</div>